package pl.finn.forms.fk02

object Fk02Data {
  val listOfBudgetFacility = listOf(
    "Gmina",
    "Powiat"
  )
  
  val countryCodeMap = mapOf(

    "AF" to "Afganistan-AF",
    "AL" to "Albania-AL",
    "DZ" to "Algieria-DZ",
    "AD" to "Andora-AD",
    "AO" to "Angola-AO",
    "AI" to "Anguilla-AI",
    "AQ" to "Antarktyda-AQ",
    "AG" to "Antigua i Barbuda-AG",
    "SA" to "Arabia Saudyjska-SA",
    "AR" to "Argentyna-AR",
    "AM" to "Armenia-AM",
    "AW" to "Aruba-AW",
    "AU" to "Australia-AU",
    "AT" to "Austria-AT",
    "AZ" to "Azerbejdżan-AZ",
    "BS" to "Bahamy-BS",
    "BH" to "Bahrajn-BH",
    "BD" to "Bangladesz-BD",
    "BB" to "Barbados-BB",
    "BE" to "Belgia-BE",
    "BZ" to "Belize-BZ",
    "BJ" to "Benin-BJ",
    "BM" to "Bermudy-BM",
    "BT" to "Bhutan-BT",
    "BY" to "Białoruś-BY",
    "MM" to "Birma-MM",
    "BO" to "Boliwia-BO",
    "BQ" to "Bonaire Sint Eustatius i Saba-BQ",
    "BA" to "Bośnia i Hercegowina-BA",
    "BW" to "Botswana-BW",
    "BR" to "Brazylia-BR",
    "BN" to "Brunei-BN",
    "IO" to "Brytyjskie Terytorium Oceanu Indyjskiego-IO",
    "VG" to "Brytyjskie Wyspy Dziewicze-VG",
    "BG" to "Bułgaria-BG",
    "BF" to "Burkina Faso-BF",
    "BI" to "Burundi-BI",
    "CL" to "Chile-CL",
    "CN" to "Chiny-CN",
    "HR" to "Chorwacja-HR",
    "CW" to "Curaçao-CW",
    "CY" to "Cypr-CY",
    "TD" to "Czad-TD",
    "ME" to "Czarnogóra-ME",
    "CZ" to "Czechy-CZ",
    "UM" to "Dalekie Wyspy Mniejsze Stanów Zjednoczonych-UM",
    "DK" to "Dania-DK",
    "CD" to "Demokratyczna Republika Konga-CD",
    "DM" to "Dominika-DM",
    "DO" to "Dominikana-DO",
    "DJ" to "Dżibuti-DJ",
    "EG" to "Egipt-EG",
    "EC" to "Ekwador-EC",
    "ER" to "Erytrea-ER",
    "EE" to "Estonia-EE",
    "ET" to "Etiopia-ET",
    "FK" to "Falklandy-FK",
    "FJ" to "Fidżi-FJ",
    "PH" to "Filipiny-PH",
    "FI" to "Finlandia-FI",
    "FR" to "Francja-FR",
    "TF" to "Francuskie Terytoria Południowe i Antarktyczne-TF",
    "GA" to "Gabon-GA",
    "GM" to "Gambia-GM",
    "GS" to "Georgia Południowa i Sandwich Południowy-GS",
    "GH" to "Ghana-GH",
    "GI" to "Gibraltar-GI",
    "GR" to "Grecja-GR",
    "GD" to "Grenada-GD",
    "GL" to "Grenlandia-GL",
    "GE" to "Gruzja-GE",
    "GU" to "Guam-GU",
    "GG" to "Guernsey-GG",
    "GF" to "Gujana Francuska-GF",
    "GY" to "Gujana-GY",
    "GP" to "Gwadelupa-GP",
    "GT" to "Gwatemala-GT",
    "GW" to "Gwinea Bissau-GW",
    "GQ" to "Gwinea Równikowa-GQ",
    "GN" to "Gwinea-GN",
    "HT" to "Haiti-HT",
    "ES" to "Hiszpania-ES",
    "NL" to "Holandia-NL",
    "HN" to "Honduras-HN",
    "HK" to "Hongkong-HK",
    "IN" to "Indie-IN",
    "ID" to "Indonezja-ID",
    "IQ" to "Irak-IQ",
    "IR" to "Iran-IR",
    "IE" to "Irlandia-IE",
    "IS" to "Islandia-IS",
    "IL" to "Izrael-IL",
    "JM" to "Jamajka-JM",
    "JP" to "Japonia-JP",
    "YE" to "Jemen-YE",
    "JE" to "Jersey-JE",
    "JO" to "Jordania-JO",
    "KY" to "Kajmany-KY",
    "KH" to "Kambodża-KH",
    "CM" to "Kamerun-CM",
    "CA" to "Kanada-CA",
    "QA" to "Katar-QA",
    "KZ" to "Kazachstan-KZ",
    "KE" to "Kenia-KE",
    "KG" to "Kirgistan-KG",
    "KI" to "Kiribati-KI",
    "CO" to "Kolumbia-CO",
    "KM" to "Komory-KM",
    "CG" to "Kongo-CG",
    "KR" to "Korea Południowa-KR",
    "KP" to "Korea Północna-KP",
    "CR" to "Kostaryka-CR",
    "CU" to "Kuba-CU",
    "KW" to "Kuwejt-KW",
    "LA" to "Laos-LA",
    "LS" to "Lesotho-LS",
    "LB" to "Liban-LB",
    "LR" to "Liberia-LR",
    "LY" to "Libia-LY",
    "LI" to "Liechtenstein-LI",
    "LT" to "Litwa-LT",
    "LU" to "Luksemburg-LU",
    "LV" to "Łotwa-LV",
    "MK" to "Macedonia-MK",
    "MG" to "Madagaskar-MG",
    "YT" to "Majotta-YT",
    "MO" to "Makau-MO",
    "MW" to "Malawi-MW",
    "MV" to "Malediwy-MV",
    "MY" to "Malezja-MY",
    "ML" to "Mali-ML",
    "MT" to "Malta-MT",
    "MP" to "Mariany Północne-MP",
    "MA" to "Maroko-MA",
    "MQ" to "Martynika-MQ",
    "MR" to "Mauretania-MR",
    "MU" to "Mauritius-MU",
    "MX" to "Meksyk-MX",
    "FM" to "Mikronezja-FM",
    "MD" to "Mołdawia-MD",
    "MC" to "Monako-MC",
    "MN" to "Mongolia-MN",
    "MS" to "Montserrat-MS",
    "MZ" to "Mozambik-MZ",
    "NA" to "Namibia-NA",
    "NR" to "Nauru-NR",
    "NP" to "Nepal-NP",
    "DE" to "Niemcy-DE",
    "NE" to "Niger-NE",
    "NG" to "Nigeria-NG",
    "NI" to "Nikaragua-NI",
    "NU" to "Niue-NU",
    "NF" to "Norfolk-NF",
    "NO" to "Norwegia-NO",
    "NC" to "Nowa Kaledonia-NC",
    "NZ" to "Nowa Zelandia-NZ",
    "OM" to "Oman-OM",
    "PK" to "Pakistan-PK",
    "PW" to "Palau-PW",
    "PS" to "Palestyna-PS",
    "PA" to "Panama-PA",
    "PG" to "Papua-Nowa Gwinea-PG",
    "PY" to "Paragwaj-PY",
    "PE" to "Peru-PE",
    "PN" to "Pitcairn-PN",
    "PF" to "Polinezja Francuska-PF",
    "PL" to "Polska-PL",
    "PR" to "Portoryko-PR",
    "PT" to "Portugalia-PT",
    "TW" to "Tajwan-TW",
    "ZA" to "Republika Południowej Afryki-ZA",
    "CF" to "Republika Środkowoafrykańska-CF",
    "CV" to "Republika Zielonego Przylądka-CV",
    "RE" to "Reunion-RE",
    "RU" to "Rosja-RU",
    "RO" to "Rumunia-RO",
    "RW" to "Rwanda-RW",
    "EH" to "Sahara Zachodnia-EH",
    "KN" to "Saint Kitts i Nevis-KN",
    "LC" to "Saint Lucia-LC",
    "VC" to "Saint Vincent i Grenadyny-VC",
    "BL" to "Saint-Barthélemy-BL",
    "MF" to "Saint-Martin-MF",
    "PM" to "Saint-Pierre i Miquelon-PM",
    "SV" to "Salwador-SV",
    "AS" to "Samoa Amerykańskie-AS",
    "WS" to "Samoa-WS",
    "SM" to "San Marino-SM",
    "SN" to "Senegal-SN",
    "RS" to "Serbia-RS",
    "SC" to "Seszele-SC",
    "SL" to "Sierra Leone-SL",
    "SG" to "Singapur-SG",
    "SX" to "Sint Maarten-SX",
    "SK" to "Słowacja-SK",
    "SI" to "Słowenia-SI",
    "SO" to "Somalia-SO",
    "LK" to "Sri Lanka-LK",
    "US" to "Stany Zjednoczone-US",
    "SZ" to "Suazi-SZ",
    "SD" to "Sudan-SD",
    "SR" to "Surinam-SR",
    "SJ" to "Svalbard i Jan Mayen-SJ",
    "SY" to "Syria-SY",
    "CH" to "Szwajcaria-CH",
    "SE" to "Szwecja-SE",
    "TJ" to "Tadżykistan-TJ",
    "TH" to "Tajlandia-TH",
    "TZ" to "Tanzania-TZ",
    "TL" to "Timor Wschodni-TL",
    "TG" to "Togo-TG",
    "TK" to "Tokelau-TK",
    "TO" to "Tonga-TO",
    "TT" to "Trynidad i Tobago-TT",
    "TN" to "Tunezja-TN",
    "TR" to "Turcja-TR",
    "TM" to "Turkmenistan-TM",
    "TC" to "Turks i Caicos-TC",
    "TV" to "Tuvalu-TV",
    "UG" to "Uganda-UG",
    "UA" to "Ukraina-UA",
    "UY" to "Urugwaj-UY",
    "UZ" to "Uzbekistan-UZ",
    "VU" to "Vanuatu-VU",
    "WF" to "Wallis i Futuna-WF",
    "VA" to "Watykan-VA",
    "VE" to "Wenezuela-VE",
    "HU" to "Węgry-HU",
    "GB" to "Wielka Brytania-GB",
    "VN" to "Wietnam-VN",
    "IT" to "Włochy-IT",
    "CI" to "Wybrzeże Kości Słoniowej-CI",
    "BV" to "Wyspa Bouveta-BV",
    "CX" to "Wyspa Bożego Narodzenia-CX",
    "IM" to "Wyspa Man-IM",
    "SH" to "Wyspa Świętej Heleny Wyspa Wniebowstąpienia i Tristan da Cunha-SH",
    "AX" to "Wyspy Alandzkie-AX",
    "CK" to "Wyspy Cooka-CK",
    "VI" to "Wyspy Dziewicze Stanów Zjednoczonych-VI",
    "HM" to "Wyspy Heard i McDonalda-HM",
    "CC" to "Wyspy Kokosowe-CC",
    "MH" to "Wyspy Marshalla-MH",
    "FO" to "Wyspy Owcze-FO",
    "SB" to "Wyspy Salomona-SB",
    "ST" to "Wyspy Świętego Tomasza i Książęca-ST",
    "ZM" to "Zambia-ZM",
    "ZW" to "Zimbabwe-ZW",
    "AE" to "Zjednoczone Emiraty Arabskie-AE"
  )
}